import React from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import ReactSVG from "react-svg";
import { withTranslation } from "react-i18next";

const LINK_SVG_PATH = "/data/svg/history/link.svg";

const SpecInstanceRefItem = props => {
    const {
        t,
        data: { actionName, objectId, objectType, specFrom, specTo },
    } = props;

    const isCurrentFrom = specFrom?.objectId === objectId && specFrom?.objectType === objectType;
    const isCurrentTo = specTo?.objectId === objectId && specTo?.objectType === objectType;

    const renderLink = props => {
        const { href, children } = props;
        return (
            <a href={href} className="custom-link" rel="noreferrer">
                <ReactSVG src={LINK_SVG_PATH} className="history-svg-icon" />
                <span>{children}</span>
            </a>
        );
    };

    const getMarkdownProps = value => ({
        source: value,
        unwrapDisallowed: true,
        disallowedTypes: ["paragraph"],
        renderers: {
            link: renderLink,
        },
    });

    const renderCardBlock = (label, name, uri, isCurrent) => (
        <div className="history-item">
            <div className="history-item-content history-item-change">
                <div className="history-content-attribute">
                    <div>{label}:</div>
                </div>
                <div className="history-content-text-wrapper">
                    <div className="history-content-text">
                        <div>
                            <div className="specinstanceref-name">{name}</div>
                            <div>
                                {isCurrent && (
                                    <span className="specinstanceref-current">{t("specification.currentCard")}</span>
                                )}
                                {uri && <ReactMarkdown {...getMarkdownProps(uri)} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <>
            <div className="history-change-item-type">{actionName}</div>

            {renderCardBlock(t("specification.newCard"), specTo?.name, specTo?.uri, isCurrentTo)}
            {renderCardBlock(t("specification.oldCard"), specFrom?.name, specFrom?.uri, isCurrentFrom)}
        </>
    );
};

SpecInstanceRefItem.propTypes = {
    data: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default withTranslation()(SpecInstanceRefItem);
